import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../utils/api';
import { useAuthStore } from '../store/authStore';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { 
  User, Music, Save, Check, Loader2, Link2, Disc, AlertCircle, Camera, Plus, X, Image
} from 'lucide-react';
import { toast } from 'sonner';

const SpotifyIcon = () => <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/></svg>;
const SoundCloudIcon = () => <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M1.175 12.225c-.051 0-.094.046-.101.1l-.233 2.154.233 2.105c.007.058.05.098.101.098.05 0 .09-.04.099-.098l.255-2.105-.27-2.154c-.009-.06-.052-.1-.084-.1zm-.899 1.125c-.051 0-.094.046-.101.1l-.165 1.175.165 1.095c.007.058.05.098.101.098.05 0 .09-.04.099-.098l.18-1.095-.195-1.175c-.009-.06-.052-.1-.084-.1z"/></svg>;
const YouTubeIcon = () => <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>;
const InstagramIcon = () => <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>;
const TikTokIcon = () => <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.78a8.18 8.18 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.21z"/></svg>;
const AppleMusicIcon = () => <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M23.994 6.124a9.23 9.23 0 00-.24-2.19c-.317-1.31-1.062-2.31-2.18-3.043a5.022 5.022 0 00-1.877-.726 10.496 10.496 0 00-1.564-.15c-.04-.003-.083-.01-.124-.013H5.99c-.152.01-.303.017-.455.026-.747.043-1.49.123-2.193.4-1.336.53-2.3 1.452-2.865 2.78-.192.448-.292.925-.363 1.408-.056.392-.088.785-.1 1.18 0 .032-.007.062-.01.093v12.223c.01.14.017.283.027.424.05.815.154 1.624.497 2.373.65 1.42 1.738 2.353 3.234 2.801.42.127.856.187 1.293.228.555.053 1.11.06 1.667.06h11.03c.525 0 1.048-.034 1.57-.1.823-.106 1.597-.35 2.296-.81a5.046 5.046 0 001.88-2.207c.186-.42.293-.87.37-1.324.113-.675.138-1.358.137-2.04-.002-3.8 0-7.595-.003-11.393z"/></svg>;
const BeatportIcon = () => <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M21.429 6.857H2.571A2.571 2.571 0 000 9.429v5.142a2.571 2.571 0 002.571 2.572h18.858A2.571 2.571 0 0024 14.571V9.429a2.571 2.571 0 00-2.571-2.572zM12 15.429a3.429 3.429 0 110-6.858 3.429 3.429 0 010 6.858z"/></svg>;

// Validate music/social URL formats
const URL_VALIDATORS = {
  soundcloud_url:  { pattern: /^https?:\/\/(www\.|m\.)?soundcloud\.com\/[a-zA-Z0-9_-]+(\/.*)?$/, example: 'https://soundcloud.com/your-profile' },
  spotify_url:     { pattern: /^https?:\/\/open\.spotify\.com\/(artist|user|album|track|playlist)\/.+$/, example: 'https://open.spotify.com/artist/...' },
  youtube_url:     { pattern: /^https?:\/\/(www\.|m\.)?youtube\.com\/(@[\w.-]+|channel\/.+|c\/.+|user\/.+)$/, example: 'https://youtube.com/@your-channel' },
  instagram_url:   { pattern: /^https?:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9_.]+\/?$/, example: 'https://instagram.com/your-handle' },
  tiktok_url:      { pattern: /^https?:\/\/(www\.|vm\.)?tiktok\.com\/@?[a-zA-Z0-9_.]+\/?$/, example: 'https://tiktok.com/@your-handle' },
  apple_music_url: { pattern: /^https?:\/\/music\.apple\.com\/.+$/, example: 'https://music.apple.com/artist/...' },
  beatport_url:    { pattern: /^https?:\/\/(www\.)?beatport\.com\/(artist|label|release|track)\/.+$/, example: 'https://beatport.com/artist/...' },
  mixcloud_url:    { pattern: /^https?:\/\/(www\.)?mixcloud\.com\/[a-zA-Z0-9_-]+(\/.*)?$/, example: 'https://mixcloud.com/your-profile' },
  bandcamp_url:    { pattern: /^https?:\/\/[a-zA-Z0-9_-]+\.bandcamp\.com(\/.*)?$/, example: 'https://yourname.bandcamp.com' },
};

const isValidSoundCloudUrl = (url) => {
  if (!url || !url.trim()) return true;
  return URL_VALIDATORS.soundcloud_url.pattern.test(url.trim());
};

const validateUrl = (fieldKey, value) => {
  if (!value || !value.trim()) return null; // empty is fine
  const v = URL_VALIDATORS[fieldKey];
  if (!v) return null;
  return v.pattern.test(value.trim()) ? null : `Expected: ${v.example}`;
};

// Inline editable field - shows a check button when value changes
const InlineField = ({ label, value, onChange, placeholder, type = 'text', icon: Icon, iconColor, saveFn, fieldKey }) => {
  const [original, setOriginal] = useState(value);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');
  const isDirty = value !== original;

  const handleSave = async () => {
    // SoundCloud validation
    if (fieldKey === 'soundcloud_url' && !isValidSoundCloudUrl(value)) {
      setError('Use format: https://soundcloud.com/your-profile');
      return;
    }
    setError('');
    setSaving(true);
    try {
      await saveFn({ [fieldKey]: type === 'number' ? (parseFloat(value) || 0) : value });
      setOriginal(value);
      setSaved(true);
      setTimeout(() => setSaved(false), 1500);
      toast.success(`${label} updated!`);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (detail) { setError(detail); toast.error(detail); }
      else { toast.error(`Failed to update ${label}`); }
    } finally {
      setSaving(false);
    }
  };

  // Sync original when external data loads
  React.useEffect(() => { setOriginal(value); }, []); // eslint-disable-line

  return (
    <div className="p-4 bg-white/5 rounded-xl border border-white/10" data-testid={`field-${fieldKey}`}>
      <div className="flex items-center gap-3">
        {Icon && (
          <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${iconColor || 'bg-violet-500/20 text-violet-400'}`}>
            <Icon />
          </div>
        )}
        <div className="flex-1">
          <Label className="text-white/80 text-sm flex items-center gap-2">
            {label}
            {value && !isDirty && <span className="text-emerald-400 text-xs flex items-center gap-0.5"><Check size={10} /> Linked</span>}
          </Label>
          <Input
            type={type}
            value={value}
            onChange={(e) => { onChange(e.target.value); setError(''); }}
            placeholder={placeholder}
            className={`mt-1 bg-white/5 border-white/10 text-white ${error ? 'border-red-500/50' : value && !isDirty ? 'border-emerald-500/30' : ''}`}
          />
        </div>
        <button
          onClick={handleSave}
          disabled={!isDirty || saving}
          className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 transition-all ${
            saved ? 'bg-green-500 text-white'
            : isDirty ? 'bg-violet-600 hover:bg-violet-500 text-white cursor-pointer'
            : 'bg-white/5 text-white/20 cursor-default'
          }`}
          title={isDirty ? 'Save' : 'No changes'}
          data-testid={`save-${fieldKey}`}
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" />
           : saved ? <Check className="w-4 h-4" />
           : <Check className="w-4 h-4" />}
        </button>
      </div>
      {error && <p className="text-red-400 text-xs mt-2 ml-[52px]">{error}</p>}
    </div>
  );
};

// Profile Image Upload component
const ProfileImageUpload = ({ currentImage, onImageChange }) => {
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('folder', 'profile-images');
      const response = await apiClient.post('/upload-file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      await onImageChange(response.data.url);
    } catch {
      toast.error('Failed to upload image');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="p-4 bg-white/5 rounded-xl border border-white/10" data-testid="profile-image-upload">
      <Label className="text-white/80 text-sm mb-3 block">Profile Picture</Label>
      <div className="flex items-center gap-4">
        <div className="w-20 h-20 rounded-full bg-white/10 border-2 border-white/20 overflow-hidden flex items-center justify-center flex-shrink-0">
          {currentImage ? (
            <img src={currentImage} alt="Profile" className="w-full h-full object-cover" />
          ) : (
            <User className="w-8 h-8 text-white/30" />
          )}
        </div>
        <div className="flex-1">
          <input type="file" id="pfp-upload" accept="image/*" onChange={handleUpload} className="hidden" disabled={uploading} />
          <Button
            type="button" data-testid="upload-pfp-btn"
            onClick={() => document.getElementById('pfp-upload').click()}
            disabled={uploading}
            className="bg-violet-600 hover:bg-violet-500 text-sm"
          >
            {uploading ? <><Loader2 className="w-4 h-4 animate-spin mr-2" /> Uploading...</> : <><Camera className="w-4 h-4 mr-2" /> Change Photo</>}
          </Button>
          <p className="text-white/40 text-xs mt-2">JPG, PNG or WebP. Will be displayed on your profile.</p>
        </div>
      </div>
    </div>
  );
};

// Media Photos Manager component
const MediaPhotosManager = ({ photos, onPhotosChange }) => {
  const [uploading, setUploading] = useState(false);
  const [urlInput, setUrlInput] = useState('');

  const handleUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    setUploading(true);
    try {
      const newUrls = [];
      for (let file of files) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('folder', 'artist-media');
        const response = await apiClient.post('/upload-file', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        newUrls.push(response.data.url);
      }
      await onPhotosChange([...photos, ...newUrls]);
    } catch {
      toast.error('Failed to upload photos');
    } finally {
      setUploading(false);
    }
  };

  const addUrl = async () => {
    if (!urlInput.trim()) return;
    await onPhotosChange([...photos, urlInput.trim()]);
    setUrlInput('');
  };

  const removePhoto = async (index) => {
    const updated = photos.filter((_, i) => i !== index);
    await onPhotosChange(updated);
  };

  return (
    <div data-testid="media-photos-manager">
      <div className="flex gap-2 mb-4">
        <input type="file" id="media-upload" multiple accept="image/*" onChange={handleUpload} className="hidden" disabled={uploading} />
        <Button
          type="button" data-testid="upload-media-btn"
          onClick={() => document.getElementById('media-upload').click()}
          disabled={uploading}
          className="bg-fuchsia-600 hover:bg-fuchsia-500 flex-1"
        >
          {uploading ? <><Loader2 className="w-4 h-4 animate-spin mr-2" /> Uploading...</> : <><Plus className="w-4 h-4 mr-2" /> Upload Photos</>}
        </Button>
      </div>
      <div className="flex gap-2 mb-4">
        <Input
          data-testid="media-url-input"
          value={urlInput}
          onChange={(e) => setUrlInput(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && addUrl()}
          placeholder="Or paste image URL..."
          className="bg-white/5 border-white/10 text-white flex-1"
        />
        <Button type="button" onClick={addUrl} className="bg-violet-600 hover:bg-violet-500">
          <Plus className="w-4 h-4" />
        </Button>
      </div>
      {photos.length > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {photos.map((url, idx) => (
            <div key={idx} className="relative group aspect-video rounded-lg overflow-hidden bg-white/5 border border-white/10">
              <img src={url} alt={`Photo ${idx + 1}`} className="w-full h-full object-cover"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
              <button
                onClick={() => removePhoto(idx)}
                className="absolute top-1 right-1 w-6 h-6 rounded-full bg-red-500/80 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                data-testid={`remove-photo-${idx}`}
              >
                <X className="w-3 h-3" />
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-white/30 border border-dashed border-white/10 rounded-lg">
          <Image className="w-8 h-8 mx-auto mb-2 opacity-50" />
          <p className="text-sm">No photos yet. Upload some to showcase your work!</p>
        </div>
      )}
    </div>
  );
};

export default function ArtistSettings() {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('profile');
  const [artistStatus, setArtistStatus] = useState('');
  const [artistEmail, setArtistEmail] = useState('');
  const [profileForm, setProfileForm] = useState({
    bio: '', genres: [], local_area: '', profile_image: '', media_urls: []
  });
  const [musicLinks, setMusicLinks] = useState({
    spotify_url: '', soundcloud_url: '', youtube_url: '', instagram_url: '',
    tiktok_url: '', apple_music_url: '', beatport_url: '', mixcloud_url: '', bandcamp_url: ''
  });

  const genreOptions = [
    'Riddim', 'Dubstep', 'DeepDub', 'Experimental',
    'House', 'Techno', 'Trance', 'Drum & Bass', 'EDM',
    'Hip Hop', 'R&B', 'Pop', 'Rock', 'Jazz', 'Reggae', 'Latin',
    'Afrobeats', 'Amapiano', 'Bass House', 'Future Bass',
    'Progressive House', 'Deep House', 'Tech House', 'Melodic Techno'
  ];

  useEffect(() => { fetchArtistProfile(); }, []);

  const fetchArtistProfile = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get('/artist/profile');
      const p = response.data;
      setArtistStatus(p.status || 'pending');
      setArtistEmail(p.artist_email || '');
      setProfileForm({ bio: p.bio || '', genres: p.genres || [], local_area: p.local_area || '', profile_image: p.profile_image || '', media_urls: p.media_urls || [] });
      setMusicLinks({
        spotify_url: p.spotify_url || '', soundcloud_url: p.soundcloud_url || '',
        youtube_url: p.youtube_url || '', instagram_url: p.instagram_url || '',
        tiktok_url: p.tiktok_url || '', apple_music_url: p.apple_music_url || '',
        beatport_url: p.beatport_url || '', mixcloud_url: p.mixcloud_url || '',
        bandcamp_url: p.bandcamp_url || ''
      });
    } catch (error) {
      if (error.response?.status === 404) { navigate('/become-artist'); }
      else { toast.error('Failed to load profile'); }
    } finally { setLoading(false); }
  };

  // Save a single field to the API
  const saveField = async (data) => {
    await apiClient.put('/artist/profile', data);
  };

  // Save genres (special case — toggle then save)
  const [savingGenres, setSavingGenres] = useState(false);
  const toggleGenre = (genre) => {
    setProfileForm(prev => ({
      ...prev,
      genres: prev.genres.includes(genre) ? prev.genres.filter(g => g !== genre) : [...prev.genres, genre]
    }));
  };
  const saveGenres = async () => {
    setSavingGenres(true);
    try {
      await saveField({ genres: profileForm.genres });
      toast.success('Genres updated!');
    } catch { toast.error('Failed to update genres'); }
    finally { setSavingGenres(false); }
  };

  const isPending = artistStatus === 'pending';

  if (loading) return (
    <div className="min-h-screen bg-gradient-to-b from-gray-950 to-black flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-violet-400" />
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-950 to-black text-white p-6 md:p-10">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-2xl md:text-3xl font-bold">Artist Settings</h1>
          <Button variant="outline" onClick={() => navigate('/artist/dashboard')} className="border-white/20">Dashboard</Button>
        </div>

        {isPending && (
          <div className="mb-6 p-4 rounded-xl bg-yellow-500/10 border border-yellow-500/20 flex items-center gap-3">
            <AlertCircle className="w-5 h-5 text-yellow-400 shrink-0" />
            <p className="text-yellow-200 text-sm">Your profile is pending approval. You can still edit your info.</p>
          </div>
        )}

        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList className="bg-white/5 border border-white/10 p-1">
            <TabsTrigger value="profile" className="data-[state=active]:bg-violet-600">
              <User className="w-4 h-4 mr-2" /> Edit Profile
            </TabsTrigger>
            <TabsTrigger value="photos" className="data-[state=active]:bg-violet-600">
              <Camera className="w-4 h-4 mr-2" /> Photos
            </TabsTrigger>
            <TabsTrigger value="music" className="data-[state=active]:bg-violet-600">
              <Music className="w-4 h-4 mr-2" /> Music Links
            </TabsTrigger>
          </TabsList>

          {/* Profile Tab */}
          <TabsContent value="profile">
            <Card className="bg-white/5 border-white/10">
              <CardHeader>
                <CardTitle className="text-white flex items-center gap-2">
                  <User className="w-5 h-5 text-violet-400" /> Edit Artist Profile
                </CardTitle>
                <p className="text-white/50 text-sm mt-1">Change any field and click the check to save it instantly.</p>
              </CardHeader>
              <CardContent className="space-y-4">
                {/* Artist Email (read-only, shown when approved) */}
                {artistEmail && (
                  <div className="p-4 bg-emerald-500/10 rounded-xl border border-emerald-500/20" data-testid="artist-email-display">
                    <Label className="text-emerald-300 text-sm">Artist Email</Label>
                    <p className="text-white font-medium mt-1">{artistEmail}</p>
                    <p className="text-white/40 text-xs mt-1">This email was assigned when your profile was approved</p>
                  </div>
                )}

                {/* Profile Image */}
                <ProfileImageUpload
                  currentImage={profileForm.profile_image}
                  onImageChange={async (url) => {
                    setProfileForm(prev => ({ ...prev, profile_image: url }));
                    await saveField({ profile_image: url });
                    toast.success('Profile image updated!');
                  }}
                />

                {/* Bio - textarea with inline save */}
                <div className="p-4 bg-white/5 rounded-xl border border-white/10" data-testid="field-bio">
                  <div className="flex items-center justify-between mb-2">
                    <Label className="text-white/80">Artist Bio</Label>
                    <InlineSaveBtn
                      original="" fieldValue={profileForm.bio}
                      onSave={async () => { await saveField({ bio: profileForm.bio }); toast.success('Bio updated!'); }}
                    />
                  </div>
                  <textarea
                    value={profileForm.bio}
                    onChange={(e) => setProfileForm(prev => ({ ...prev, bio: e.target.value }))}
                    placeholder="Tell people about yourself and your music style..."
                    rows={3}
                    className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder:text-white/30 focus:border-violet-500 outline-none resize-none text-sm"
                  />
                </div>

                {/* Genres */}
                <div className="p-4 bg-white/5 rounded-xl border border-white/10" data-testid="field-genres">
                  <div className="flex items-center justify-between mb-3">
                    <Label className="text-white/80">Genres</Label>
                    <button
                      onClick={saveGenres}
                      disabled={savingGenres}
                      className="w-8 h-8 rounded-full flex items-center justify-center bg-violet-600 hover:bg-violet-500 text-white transition-all"
                      title="Save genres"
                      data-testid="save-genres"
                    >
                      {savingGenres ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
                    </button>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {genreOptions.map(g => (
                      <button key={g} type="button" onClick={() => toggleGenre(g)}
                        className={`px-3 py-1.5 rounded-full text-xs transition-all ${
                          profileForm.genres.includes(g) ? 'bg-violet-600 text-white' : 'bg-white/5 text-white/60 hover:bg-white/10'
                        }`}>{g}</button>
                    ))}
                  </div>
                </div>

                {/* Local Area */}
                <InlineField label="Local Area" value={profileForm.local_area} fieldKey="local_area"
                  onChange={(v) => setProfileForm(prev => ({ ...prev, local_area: v }))}
                  placeholder="Los Angeles, CA" saveFn={saveField} />
              </CardContent>
            </Card>
          </TabsContent>

          {/* Photos Tab */}
          <TabsContent value="photos">
            <Card className="bg-white/5 border-white/10">
              <CardHeader>
                <CardTitle className="text-white flex items-center gap-2">
                  <Image className="w-5 h-5 text-violet-400" /> Artist Photos & Media
                </CardTitle>
                <p className="text-white/50 text-sm mt-1">Upload photos that will be displayed on your artist profile.</p>
              </CardHeader>
              <CardContent className="space-y-4">
                <MediaPhotosManager
                  photos={profileForm.media_urls}
                  onPhotosChange={async (newPhotos) => {
                    setProfileForm(prev => ({ ...prev, media_urls: newPhotos }));
                    await saveField({ media_urls: newPhotos });
                    toast.success('Photos updated!');
                  }}
                />
              </CardContent>
            </Card>
          </TabsContent>

          {/* Music Links Tab */}
          <TabsContent value="music">
            <Card className="bg-white/5 border-white/10">
              <CardHeader>
                <CardTitle className="text-white flex items-center gap-2">
                  <Music className="w-5 h-5 text-violet-400" /> Music & Social Links
                </CardTitle>
                <p className="text-white/50 text-sm mt-1">Update any link and tap the check to save instantly.</p>
              </CardHeader>
              <CardContent className="space-y-3">
                {[
                  { key: 'spotify_url', label: 'Spotify', icon: SpotifyIcon, color: 'bg-[#1DB954]/20 text-[#1DB954]', ph: 'https://open.spotify.com/artist/...' },
                  { key: 'soundcloud_url', label: 'SoundCloud', icon: SoundCloudIcon, color: 'bg-[#FF5500]/20 text-[#FF5500]', ph: 'https://soundcloud.com/...' },
                  { key: 'youtube_url', label: 'YouTube', icon: YouTubeIcon, color: 'bg-[#FF0000]/20 text-[#FF0000]', ph: 'https://youtube.com/@...' },
                  { key: 'instagram_url', label: 'Instagram', icon: InstagramIcon, color: 'bg-[#E4405F]/20 text-[#E4405F]', ph: 'https://instagram.com/...' },
                  { key: 'tiktok_url', label: 'TikTok', icon: TikTokIcon, color: 'bg-[#00f2ea]/20 text-[#00f2ea]', ph: 'https://tiktok.com/@...' },
                  { key: 'apple_music_url', label: 'Apple Music', icon: AppleMusicIcon, color: 'bg-[#FA243C]/20 text-[#FA243C]', ph: 'https://music.apple.com/artist/...' },
                  { key: 'beatport_url', label: 'Beatport', icon: BeatportIcon, color: 'bg-[#94D500]/20 text-[#94D500]', ph: 'https://beatport.com/artist/...' },
                  { key: 'mixcloud_url', label: 'Mixcloud', icon: () => <Disc className="w-5 h-5" />, color: 'bg-violet-500/20 text-violet-400', ph: 'https://mixcloud.com/...' },
                  { key: 'bandcamp_url', label: 'Bandcamp', icon: () => <Link2 className="w-5 h-5" />, color: 'bg-[#629aa9]/20 text-[#629aa9]', ph: 'https://yourname.bandcamp.com' },
                ].map(({ key, label, icon, color, ph }) => (
                  <InlineField
                    key={key} label={label} fieldKey={key}
                    value={musicLinks[key]}
                    onChange={(v) => setMusicLinks(prev => ({ ...prev, [key]: v }))}
                    placeholder={ph} icon={icon} iconColor={color} saveFn={saveField}
                  />
                ))}
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}

// Small save button used for textarea/special fields
function InlineSaveBtn({ onSave }) {
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const handleClick = async () => {
    setSaving(true);
    try { await onSave(); setSaved(true); setTimeout(() => setSaved(false), 1500); }
    catch { /* handled in onSave */ }
    finally { setSaving(false); }
  };
  return (
    <button onClick={handleClick} disabled={saving}
      className={`w-8 h-8 rounded-full flex items-center justify-center transition-all ${
        saved ? 'bg-green-500 text-white' : 'bg-violet-600 hover:bg-violet-500 text-white'
      }`} title="Save" data-testid="save-bio">
      {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
    </button>
  );
}
